import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a473b70"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "MQARegularQuota" }
const _hoisted_2 = { class: "MQARegularQuota__container" }
const _hoisted_3 = { class: "right" }
const _hoisted_4 = {
  key: 0,
  class: "listTable"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "周期"),
    /*#__PURE__*/_createElementVNode("th", null, "额度(元)")
  ])
], -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "...", -1))
const _hoisted_9 = {
  key: 1,
  class: "noData"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "暂无定期额度", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "设置后每月/每周分配固定额度", -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { class: "MQAModal__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_input_number = _resolveComponent("input-number")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_QuestionCircleOutlined = _resolveComponent("QuestionCircleOutlined")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_form, { class: "left" }, {
        default: _withCtx(() => [
          _createElementVNode("h3", null, "批量将" + _toDisplayString(_ctx.actionProps.activeObjectName) + "的定期额度设置为:", 1),
          _createVNode(_component_a_form_item, { class: "margeNone" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input_group, {
                class: "form",
                compact: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    value: _ctx.formData.refreshCycle,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.refreshCycle) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select_option, { value: 2 }, {
                        default: _withCtx(() => [
                          _createTextVNode("每月")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"]),
                  _createVNode(_component_input_number, {
                    value: _ctx.formData.quotaAmount,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.quotaAmount) = $event)),
                    style: {"width":"180px"},
                    placeholder: "请输入正数金额"
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "生效时间",
            required: "",
            style: {"margin-bottom":"0"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_radio_group, {
                value: _ctx.formData.timelinessFlag,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.timelinessFlag) = $event)),
                onChange: _ctx.changeEffectTime
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_radio, { value: 1 }, {
                    default: _withCtx(() => [
                      _createTextVNode("立即生效")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_radio, { value: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.formData.refreshCycle === 1 ? '次周' : '次月') + "生效 ", 1),
                      _createVNode(_component_a_tooltip, { color: "#333" }, {
                        title: _withCtx(() => [
                          _createElementVNode("span", null, "(" + _toDisplayString(_ctx.timeStr) + " 00:00:00)", 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_QuestionCircleOutlined, { class: "circleOutlined" })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_radio, { value: 2 }, {
                    default: _withCtx(() => [
                      _createTextVNode("自定义")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value", "onChange"]),
              ([0, 1].includes(_ctx.formData.timelinessFlag))
                ? (_openBlock(), _createBlock(_component_a_checkbox, {
                    key: 0,
                    checked: _ctx.clearCycle,
                    "onUpdate:checked": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.clearCycle) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.formData.refreshCycle === 1 ? '周末' : '月底') + "剩余额度清零", 1)
                    ]),
                    _: 1
                  }, 8, ["checked"]))
                : _createCommentVNode("", true),
              (_ctx.formData.timelinessFlag === 2)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_a_checkbox, {
                      checked: _ctx.clearCycle,
                      "onUpdate:checked": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.clearCycle) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("剩余定期额度清零")
                      ]),
                      _: 1
                    }, 8, ["checked"]),
                    _createElementVNode("div", null, [
                      _createTextVNode(" 每月 "),
                      _createVNode(_component_a_select, {
                        value: _ctx.formData.effectiveDate,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.effectiveDate) = $event)),
                        style: {"width":"70px"},
                        onChange: _ctx.changeEffectDate
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateList, (item) => {
                            return (_openBlock(), _createBlock(_component_a_select_option, {
                              key: item,
                              value: item
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["value", "onChange"]),
                      _createTextVNode(" 号0点生效 ")
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.formData.quotaAmount)
          ? (_openBlock(), _createElementBlock("table", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableList, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, _toDisplayString(item), 1),
                    (_ctx.formData.timelinessFlag && !index)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_6, _toDisplayString(_ctx.showDate ? _ctx.formatCny(_ctx.formData.quotaAmount) : '--'), 1))
                      : (_openBlock(), _createElementBlock("td", _hoisted_7, _toDisplayString((!index && !_ctx.formData.timelinessFlag) ? '--' : _ctx.formatCny(_ctx.formData.quotaAmount)), 1))
                  ]))
                }), 128)),
                _createElementVNode("tr", null, [
                  _hoisted_8,
                  _createElementVNode("td", null, _toDisplayString(_ctx.formatCny(_ctx.formData.quotaAmount)), 1)
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_12))
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_a_button, {
        style: {"margin-right":"14px"},
        onClick: _ctx.onCancel
      }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_a_button, {
        type: "primary",
        onClick: _ctx.onSubmit
      }, {
        default: _withCtx(() => [
          _createTextVNode("保存")
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}